import React, { Component } from "react";
import PageContent from "@my-dld/components/PageContent";
import Strings from "@my-dld/assets/strings";
import PageTitle from "@my-dld/components/PageTitle";
import { DashboardBCItem, MyProfileBCItem } from "@my-dld/contexts/PageContext";
import { getEmail } from "@10x/sso";
import { trackEvent } from "@my-dld/utils/Analytics";
import { showErrorMessage } from "@my-dld/utils/UIUtils";
import { NullHandler } from "@my-dld/utils/ApiUtils";
import Lottie from "lottie-react-web";
import EmailAnim from "@my-dld/assets/animations/sending_email.json";
import LoadingBarAnim from "@my-dld/assets/animations/loading-bar.json";
import { replaceColor } from "lottie-colorify";
import { replaceNavigate } from "@my-dld/utils/StoreUtils";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { Entities, ProfileApi } from "@10x/dubai-rest-api";

const LoadingAnim = replaceColor( "#ff0000", "#0f3661", LoadingBarAnim );
export const Anim = replaceColor( "#000000", "#9f9f9f", replaceColor( "#ff0000", "#0f3661", EmailAnim ) );
type Step = "idle" | "waiting" | "sending" | "sent";

interface Props extends RoutedViewProps<any, { skipWait: boolean; showDone: boolean }> {

}

interface State {
	isWaiting: boolean;
	email: string;
	skipWait: boolean;
	showDone: boolean;
	step: Step;
	isDone: boolean;
	animSegments: number[];
}

class VerifyEmail extends Component<Props, State> {
	lottie = React.createRef<Lottie>();
	apiHandler = NullHandler;
	apiExHandler = NullHandler;

	constructor( props: Props ) {
		super( props );
		let { skipWait, showDone } = props.location.state ? props.location.state : { skipWait: false, showDone: false };
		this.state = {
			email: getEmail()!,
			skipWait: skipWait,
			showDone: showDone,
			isWaiting: false,
			step: "idle",
			isDone: false,
			animSegments: [ 0, 1 ],
		};
	}

	foo = () => {
		// debugger;
	};

	render() {
		const { skipWait, email, isWaiting, step, isDone, animSegments } = this.state;
		let message: string = "";
		let actionText: string = "";
		let messageClass: string = "";
		let action: null | ( () => void ) = null;
		if ( step === "sent" ) {
			if ( isDone ) {
				message = Strings.verification_email_sent.format( [ email ] );
				action = this.goBack;
				actionText = Strings.back;
				messageClass = "alert-success";
			} else {
				message = Strings.sending_verification.format( [ email ] );
				messageClass = "alert-info";
				action = null;
			}

		} else if ( step === "waiting" ) {
			if ( skipWait ) {
				message = Strings.sending_verification.format( [ email ] );
				messageClass = "alert-info";
				action = null;
			} else {
				message = Strings.will_send_verification_email.format( [ email ] );
				messageClass = "alert-info";
				action = this.onUpdate;
				actionText = Strings.change_email;
			}
		} else if ( step === "sending" ) {
			message = Strings.sending_verification.format( [ email ] );
			messageClass = "alert-info";
			action = null;
		} else if ( step === "idle" ) {
			if ( isDone ) {
				message = "";
				action = this.goBack;
				actionText = Strings.back;
				messageClass = "alert-info";
			}
		}
		return <PageContent title={ Strings.verify_email }>
			<PageTitle title={ Strings.verify_email } paths={ [ DashboardBCItem, MyProfileBCItem ] }/>
			<div className="msg-wrapper mb-5">
				<div className="msg-wrapper-inner">
					<div className="lottie-90">
						<Lottie
							key={ "emialanim" }
							options={ {
								animationData: Anim,
								loop: false,
							} }
							ref={ this.lottie }
							segments={ animSegments }
							forceSegments={ false }
							eventListeners={ [
								{
									eventName: "complete",
									callback: this.onAnimComplete,
								}
							] }
						/>
					</div>
					{ step !== "waiting" && <span style={ { height: 30 } }/> }
					{ step === "waiting" &&
						<div className="lottie-200">
							<Lottie
								key={ "waitLoader" }
								options={ {
									animationData: LoadingAnim,
									loop: false,
								} }
								speed={ 1.5 }
								eventListeners={ [
									{
										eventName: "complete",
										callback: this.sendEmail,
									}
								] }

								//  onComplete={ this.sendEmail }
							/>
						</div>
					}
					<div className={ "alert " + messageClass }>
						{ message }
					</div>
					{ action &&
						<div className="text-center">
							<button className="btn btn_1" onClick={ action }>{ actionText }</button>
						</div>
					}
				</div>
			</div>
		</PageContent>;
	}

	onAnimComplete = () => {
		const { step, skipWait } = this.state;
		if ( step === "sent" ) {
			this.setState( { isDone: true } );
		}
		if ( step === "sending" ) {
			this.jumpToSegment( 30, 30 );
			this.jumpToSegment( 30, 100 );
		}
	};

	jumpToSegment( from: number, to: number ) {
		this.setState( { animSegments: [ from, to ] } );
	}

	animateToNewStep = ( step: Step, oldStep: Step ) => {
		let p = 0;
		let n = 0;
		switch ( oldStep ) {
			case "idle":
				p = 0;
				break;
			case "sending":
				p = 100;
				break;
			case "sent":
				p = 190;
				break;
			case "waiting":
				p = 30;
		}
		switch ( step ) {
			case "idle":
				n = 0;
				break;
			case "sending":
				n = 100;
				break;
			case "sent":
				n = 190;
				break;
			case "waiting":
				n = 30;
		}
		this.jumpToSegment( p, n );
	};

	componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any ) {
		if ( prevState.step !== this.state.step ) {
			this.animateToNewStep( this.state.step, prevState.step );
		}
	}

	goBack = () => {
		replaceNavigate( "view" );
	};

	onUpdate = () => {
		replaceNavigate( "edit" );
	};

	startAutoSend = () => {
		this.setState( {
			step: "waiting",
		} );
	};

	componentWillUnmount() {
		this.apiHandler = NullHandler;
		this.apiExHandler = NullHandler;
		//  updateUserProfile(true);
	}

	onError = ( ex: any ) => {
		trackEvent( "VerifyEmail", "Error" );
		showErrorMessage( ex );
		this.setState( {
			step: "idle",
			isDone: true,
		} );
	};
	sendEmail = () => {
		this.setState( {
			step: "sending",
		} );
		this.apiHandler = response => {
			trackEvent( "VerifyEmail", "EmailSend" );
			this.onEmailSend();
			return response;
		};
		this.apiExHandler = this.onError;
		ProfileApi.initProfileUpdate( {
			email: this.state.email,
		} )
		.then( Entities.validateResponseX )
		.then( r => this.apiHandler( r ) ).catch( e => this.apiExHandler( e ) );
	};
	onEmailSend = () => {
		this.setState( {
			step: "sent",
		} );
	};

	componentDidMount() {
		if ( !this.state.showDone ) {
			if ( this.state.skipWait ) {
				this.sendEmail();
			} else {
				this.startAutoSend();
			}
		} else {
			this.setState( { step: "sent" } );
		}
	}

}

export default VerifyEmail;
